
/*@jsxRuntime automatic @jsxImportSource react*/
export const attributes = {
  "authors": ["ben-milne", "chase-merlin"],
  "callToAction": {
    "heading": "Get started with Rain",
    "subheading": "Spend SBC anywhere Visa is accepted",
    "button": "Sign up",
    "ctaUrl": "https://www.raincards.xyz/get-started",
    "externalUrl": true
  },
  "coverImage": {
    "alt": "Rain Cards | Brale Blog",
    "url": "/assets/blog/rain-cards/cover.png"
  },
  "date": "2023-11-07",
  "description": "Rain makes it easy to spend stablecoins anywhere Visa is accepted. Learn how to use SBC for everyday payments with Rain.",
  "discussLinkedIn": "https://www.linkedin.com/posts/brale_rain-cards-brale-activity-7127717250882519040-Y5a3/",
  "discussTwitter": "https://twitter.com/brale_xyz/status/1721951410458095845",
  "excerpt": "SBC is now available for everyday spending through Rain. Rain Cards is a corporate spend management platform that makes it easy to spend stablecoins anywhere Visa is accepted.",
  "ogImage": {
    "alt": "Rain Cards | Brale Blog",
    "url": "/assets/blog/rain-cards/opengraph.png"
  },
  "timeOverride": 2,
  "title": "Rain Cards",
  "slider": {
    "slides": [{
      "image": "/assets/blog/rain-cards/rain-slide-01.png",
      "alt": "Rain Transaction Details UI for Freehand Hotel transaction | Brale",
      "href": "https://maps.app.goo.gl/F8txN2PspLK3fWGaA",
      "title": "Visit Freehand Chicago"
    }, {
      "image": "/assets/blog/rain-cards/rain-slide-02.png",
      "alt": "Rain Transaction Details UI for Adventureland Resort transaction | Brale",
      "href": "https://maps.app.goo.gl/Y8doBZuhoaS75ADz5",
      "title": "Visit Adventureland Resort"
    }, {
      "image": "/assets/blog/rain-cards/rain-slide-03.png",
      "alt": "Rain Transaction Details UI for Dunkin' transaction | Brale",
      "href": "https://maps.app.goo.gl/3LYynz7rnzFN45PX6",
      "title": "Visit Dunkin'"
    }, {
      "image": "/assets/blog/rain-cards/rain-slide-04.png",
      "alt": "Rain Transaction Details UI for downtown Des Moines parking meter transaction | Brale",
      "href": "https://maps.app.goo.gl/7xuHz9CoyAcqvBwZA",
      "title": "Visit Horizon Line Coffee"
    }],
    "settings": {
      "adaptiveHeight": true,
      "arrows": false,
      "autoplay": true,
      "autoplaySpeed": 7500,
      "dots": true,
      "fade": true,
      "infinite": true,
      "draggable": true
    }
  }
};
import {ImageSlider} from "~/components/blog/slider";
import {ExternalLink} from "~/components/site/external-link";
import {ApplePayLogo} from "~/components/blog/graphics/apple-pay-logo";
import {GooglePayLogo} from "~/components/blog/graphics/google-pay-logo";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    h2: "h2",
    img: "img"
  }, props.components);
  return <><_components.p>{"Spending stablecoins, especially new ones, for everyday use could be a pain, but Rain has made it incredibly easy. Starting today, businesses using SBC can generate their own corporate card program using VISA cards, accepted worldwide, by onboarding their corporate spend program at "}<a rel="noreferrer" target="_blank" title="Visit Rain" href="https://www.raincards.xyz">{"Rain"}</a>{"."}</_components.p>{"\n"}<_components.p>{"How this works is remarkably simple. Here's me paying for a hotel, entertaining at Adventureland, grabbing a coffee at Dunkin, and parking in Des Moines, Iowa. This support for SBC makes it usable just like any other form of value."}</_components.p>{"\n"}<ImageSlider slides={attributes.slider.slides} settings={attributes.slider.settings} />{"\n"}<_components.p>{"Rain is built on Polygon and supports Brale-issued stablecoins as a means of payment. Using Polygon enables settlement between accounts to occur quickly with support for the card balance payment. Each repayment of the card balance happens nearly instantly at a cost to the end user of less than $0.00 based on a few transactions. Your experience with gas fees may vary."}</_components.p>{"\n"}<_components.h2>{"Problems this solves"}</_components.h2>{"\n"}<_components.p>{"Stablecoins as a form of value storage are very easy to understand. Using them in the real world, just like using a balance in a FinTech app in the real world, can be difficult. Using SBC or USDC alongside a Rain card makes the stablecoin usable anywhere VISA is accepted for your corporate card program."}</_components.p>{"\n"}<_components.p>{"Rain's undeniably flexible platform is a perfect match for regulated stablecoins and supports all the required functionality to bring a program live. For the payments people out there, it's all remarkably simple. SBC is used as the permissioned balance drawn down to pay off the card usage, the same way a FinTech balance would be interfacing with traditional finance participants."}</_components.p>{"\n"}<div className="round border border-primary not-prose my-10 bg-gray-100 dark:bg-black overflow-clip"><_components.p><_components.img src="/assets/blog/rain-cards/rain-funds-flow-graphic.png" alt="Funds flow diagram showing the end-to-end process of purchasing a taco using
stablecoins and a Rain card -
Brale" /></_components.p></div>{"\n"}<_components.p>{"Cards are supported in Apple Pay, Google Pay, and other popular mobile wallets. Physical cards can be requested and mailed. We think Rain is an excellent example of how to build a product for internet native companies that need expense management tools and the ability to spend stablecoins with merchants in the communities where employees live."}</_components.p>{"\n"}<div className="grid grid-cols-2 gap-6 my-10"><ExternalLink title="Visit Apple Pay" href="https://www.apple.com/apple-pay/"><ApplePayLogo className="w-full h-full bg-gray-100 dark:bg-black round border border-primary" /></ExternalLink><ExternalLink className="flex items-center" title="Visit Google Pay" href="https://pay.google.com/about/"><GooglePayLogo className="w-full h-full bg-gray-100 dark:bg-black round border border-primary" /></ExternalLink></div>{"\n"}<_components.p>{"To start spending your SBC or other stablecoins, you can onboard at Rain. Rain can also develop custom card programs for different companies and stablecoin programs. If you have ideas on how you could work with Rain, we'd encourage you to reach out to them directly."}</_components.p></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}
export default MDXContent;


export const filename = "rain-cards.mdx";
export const headers = typeof attributes !== "undefined" && attributes.headers;
export const meta = typeof attributes !== "undefined" && attributes.meta;
export const handle = typeof attributes !== "undefined" && attributes.handle;
    